import script from "./ChValues.vue?vue&type=script&setup=true&lang=js"
export * from "./ChValues.vue?vue&type=script&setup=true&lang=js"

import "./ChValues.vue?vue&type=style&index=0&id=9616fed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9616fed4"]])

export default __exports__